module.exports = __webpack_public_path__ + "media/images/lb/084-5bedb8200289cdb4a4418c85e785c30c.svg";